<header>
  <div class="container">
    <div class="d-flex align-items-center">
      <a class="open-menu show-on-mobile" (click)="showMenu = true">
        <img
          src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/menu-icon.svg"
          alt=""
          width="auto"
          height="auto"
        />
      </a>
      <div class="logo">
        <a (click)="goToPage('shop-fpt')" style="cursor: pointer">
          <img
            src="https://shop.fpt.vn/tin-tuc/trai-nghiem-wifi6/_next/image?url=https%3A%2F%2Fhi-static.fpt.vn%2Fsys%2Fhifpt%2Fpnc_pdx%2Flanding-wifi6%2Fheader-logo.png&w=128&q=75"
            alt=""
            width="auto"
            height="auto"
          />
        </a>
      </div>
      <nav class="menu">
        <ul>
          <li *ngFor="let menu of listMenu">
            <a (click)="moveToPage(menu.link, menu.section)">{{ menu.name }}</a>
          </li>
        </ul>
        <button (click)="registerInfo()">
          <span>Đăng ký</span>
        </button>
      </nav>
    </div>
  </div>
  <div class="menu-mobile" [ngClass]="showMenu ? 'show' : ''">
    <a class="bg" (click)="showMenu = false">&nbsp;</a>

    <ul>
      <a class="close-menu" (click)="showMenu = false">
        <img
          alt="close-toggle"
          loading="lazy"
          width="32"
          height="32"
          decoding="async"
          data-nimg="1"
          src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/close-toggle.svg"
        />
      </a>
      <li *ngFor="let menu of listMenu">
        <a (click)="moveToPage(menu.link, menu.section)">{{ menu.name }}</a>
      </li>
    </ul>
  </div>
</header>
